export default function (context, v) {
    let cb = () => {
    };
    if (v) {
        if (v.cb) cb = v.cb;
    }
    context.commit('cb', cb);

    let state = context.state;
    if(state.loading) return;
    if (state.time > new Date().getTime()) {
        context.commit('cb');
        return;
    }
    context.commit('loading', true);
    axios({
        method: 'post',
        url: '/tourclient/masterAgent/dictionary/ownerLegal/list',
        data: {
          request: JSON.stringify({ForOwn: true, IsOnlyActive: false}),
        },
    }).then(({data}) => {
        let error = '';
        if (!data) {
            error = 'Не удалось загрузить справочник: Фирмы владельца';
        } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
            error = data.ResultQueryInfo.UserMessages;
        }
        if (error) {
            window.app.$notify.error({
                title: 'Ошибка',
                message: error,
            });
        }
        context.commit('items', data);

    }).catch(e => {
        if (!e) return;
        context.commit('items');
        context.dispatch('error', e, {root: true});
    });
}